/**
 * Created by Srdjan on 7/25/2016.
 */
var survey = {}; // namespace

survey.ui = (function ($) {
    return {
        setSurveyTaken : function () {
            localStorage.isSurveyTaken = 1;
        },

        unsetSurveyTaken : function () {
            localStorage.removeItem('isSurveyTaken');
        },
        
        initSurveyButton : function (wrapper, authKey, surveyIdd) {
            
                if(localStorage.isSurveyTaken) {
                    $(wrapper).remove();
                }
                $('#take-survey').click(function(e) {
                    var csrf = '&' + yii.getCsrfParam() + '=' + yii.getCsrfToken();
                    $.get('/survey/finish-survey?key=' + authKey + '&surveyId=' + surveyIdd + csrf);
                    survey.ui.setSurveyTaken();
                    $(wrapper).remove();
                });
        }
    };
})(jQuery);

survey.shareLink = (function ($) {
    var copyFromInput = function () {
        var input = document.getElementById('survey-share-link');
        input.focus();
        input.select();

        return document.execCommand('copy') ? $.Deferred().resolve() : $.Deferred().reject();
    };

    var copyText = function (text) {
        if (!navigator.clipboard || !window.isSecureContext) {
            return copyFromInput().promise();
        }

        var deferred = $.Deferred();
        navigator.clipboard.writeText(text).then(deferred.resolve, function () {
            copyFromInput().then(deferred.resolve, deferred.reject);
        });

        return deferred.promise();
    };

    $(document).on('change', '#survey-no_validation_required', function () {
        $('.survey-share-link-group').toggleClass('hidden', !this.checked);

        var $clients = $('#survey-clientids');
        if (($clients.val() || []).length > 0) {
            $(this).closest('form').yiiActiveForm('validateAttribute', 'survey-clientids');
        }
    });

    $(document).on('click', '.survey-share-link-copy', function () {
        var $button = $(this);
        // fixTitle moves the title into data-original-title, so the original title is stored once
        if ($button.data('original-copy-title') === undefined) {
            $button.data('original-copy-title', $button.attr('title'));
        }

        var originalTitle = $button.data('original-copy-title');

        copyText($('#survey-share-link').val()).then(function () {
            $button.attr('title', $button.data('copied-text')).tooltip('fixTitle').tooltip('show');

            setTimeout(function () {
                $button.tooltip('hide').attr('title', originalTitle).tooltip('fixTitle');
            }, 1500);
        });
    });
})(jQuery);